module.exports = __webpack_public_path__ + "img/V4.5777248b.jpg";